<template>
  <div class="person">
    <div class="person-thumb" :style="'background-image:url(\'' + person.photo + '\')'"></div>
    {{person.name}}
    {{person.twitter}}
  </div>
</template>

<script>
import fb from 'firebase'

export default {
  props: {
    key: null
  },
  data: function() {
    return {
      person: {}
    }
  },
  ready: function() {
    let self = this

    fb.database().ref('people/' + this.key)
    .on('value', function(snapshot) {
      self.person = snapshot.val()
    })

  }
}
</script>

<style>
  .person-thumb {
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 50%;
    float: left;
    margin-right: 15px;
  }
</style>



/** WEBPACK FOOTER **
 ** Person.vue?e3fabc6c
 **/